import { useMemo, useState } from "react";
import type { MediaType } from "@/types";
import { movies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/base/SectionHeading";

const TABS: { value: MediaType | "all"; label: string }[] = [
  { value: "all", label: "全部" },
  { value: "movie", label: "电影" },
  { value: "tv", label: "电视剧" },
];

export default function HomeLatest() {
  const [tab, setTab] = useState<MediaType | "all">("all");

  const list = useMemo(() => {
    const sorted = [...movies].sort((a, b) => b.year - a.year || b.rating - a.rating);
    const filtered = tab === "all" ? sorted : sorted.filter((m) => m.type === tab);
    return filtered.slice(0, 6);
  }, [tab]);

  return (
    <section>
      <div className="flex items-end justify-between gap-4 mb-4 md:mb-5">
        <SectionHeading title="最新上线" subtitle="汇集近期与观众见面的电影与电视剧" icon="ri-time-line" />
      </div>

      <div className="flex items-center justify-between gap-4 mb-4">
        <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-200 max-w-full overflow-x-auto no-scrollbar">
          {TABS.map((item) => (
            <button
              key={item.value}
              type="button"
              onClick={() => setTab(item.value)}
              className={`px-4 py-1.5 rounded-full text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                tab === item.value
                  ? "bg-primary-600 text-white"
                  : "text-foreground-600 hover:text-primary-700"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
        {list.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}